import React from 'react';

/**
 * @param {string} scope - task visibility from the API: 'own' | 'department' | 'all'.
 *        Resolved server-side from Department.heads, never from permissions — the
 *        third tab exists only when the backend says the caller can see past their
 *        own tasks, so the tab and the endpoint can no longer disagree.
 * @param {boolean} isManager - holds the 'approve' action; controls approval UI only.
 */
const TaskTabs = ({ activeTab, isManager, scope, onTabChange }) => {
  const canSeeBeyondOwn = scope === 'department' || scope === 'all';

  return (
    <div className="task-tabs">
      <button
        className={`task-tab ${activeTab === 'assigned-to-me' ? 'active' : ''}`}
        onClick={() => onTabChange('assigned-to-me')}
      >
        {isManager ? '📋 Approval Requests' : '📥 Assigned to Me'}
      </button>
      <button
        className={`task-tab ${activeTab === 'assigned-by-me' ? 'active' : ''}`}
        onClick={() => onTabChange('assigned-by-me')}
      >
        📤 Assigned by Me
      </button>
      {canSeeBeyondOwn && (
        <button
          className={`task-tab ${activeTab === 'all-tasks' ? 'active' : ''}`}
          onClick={() => onTabChange('all-tasks')}
          title={scope === 'department'
            ? 'Every task in the department(s) you head'
            : 'Every task in the system'}
        >
          {scope === 'department' ? '🏢 Department Tasks' : '📊 All Tasks'}
        </button>
      )}
    </div>
  );
};

export default TaskTabs;
